export enum ReferralMatchSource {
  captureAdminUser = 'capture_admin_user',
  clientReferralTask = 'client_referral_task',
  peerClientReferralVerification = 'peer_client_referral_verification',
  ehrReferralVerification = 'ehr_referral_verification',
}
